/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import React from 'react';
import { Outlet } from 'react-router-dom';
import { ErrorBoundary } from '@sentry/react';

import styles from './ErrorScreen.module.scss';
import messageStyles from './chat/Message.module.scss';

export function ErrorScreen({
  error,
  componentStack,
  resetError,
}: {
  error: Error;
  componentStack?: string | null;
  resetError?: () => void;
}) {
  return (
    <div className={styles.errorScreen}>
      <div className={styles.heading}>
        ⚠️ An error has occurred!
        <br />
        <p /> Please retry your request or contact{' '}
        <a href="mailto:medpearlsupport@healthendeavors.com">medpearlsupport@healthendeavors.com</a> for further
        assistance.
      </div>
      <div className={styles.errorStr}>{error?.toString()}</div>
      <div className={styles.stack}>{componentStack}</div>
    </div>
  );
}

export function MessageErrorBoundary({ children }: { children: React.ReactNode }) {
  return (
    <ErrorBoundary
      fallback={({ error, componentStack, resetError }) => (
        <div className={`${messageStyles.message} ${messageStyles.response}`}>
          <ErrorScreen error={error} componentStack={componentStack} resetError={resetError} />
        </div>
      )}
    >
      {children}
    </ErrorBoundary>
  );
}

export function ErrorScreenContainer() {
  return (
    <ErrorBoundary
      fallback={({ error, componentStack, resetError }) => (
        <ErrorScreen error={error} componentStack={componentStack} resetError={resetError} />
      )}
    >
      <Outlet />
    </ErrorBoundary>
  );
}
